




import { AccountInfoDTO } from '@/api/com/MetaPattern/APP/MDA/User/AccountInfoDTO';
import { MDAAccountService } from '@/api/com/MetaPattern/APP/MDA/User/MDAAccountService';
import CacheItem from '@/libs/com/MetaPattern/Product/IDE/Util/CacheItem';
import { ValidateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ValidateHelper';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
/** 账户：录入登录账户名LoginName，系统记录id */
export default class PGRowAccountValue extends Vue {
  @Prop() private value!: string; // 登录信息ID
  @Prop() private isEditable!: boolean;
  private textValue = '';
  private accountInfoDTO: AccountInfoDTO;

  constructor() {
    super();
    this.textValue = '';
    this.accountInfoDTO = null;
  }

  mounted() {
    this.setTextValue();
  }

  setTextValue() {
    if (ValidateHelper.IsNotNullOrEmpty(this.value) && this.accountInfoDTO === null) {
      const result = this.$store.getters['ObjectCache/cacheItem'](this.value);
      if (result === null) {
        MDAAccountService.GetAccountInfoAsync()
          .then(loginAccount => {
            if (ValidateHelper.IsNotNullOrUndefined(loginAccount)) {
              this.accountInfoDTO = loginAccount;
              this.textValue = loginAccount.loginName;
              const cacheItem = new CacheItem(this.value, loginAccount, 600);
              this.$store.dispatch('ObjectCache/addItemAction', cacheItem);
            }
          });
      } else {
        this.accountInfoDTO = result;
      }
    }
    if (this.accountInfoDTO !== null) {
      this.textValue = this.accountInfoDTO.loginName;
    }
  }

  saveChange(): void {
    // MDAAccountService.LoadAccountInfoAsync(this.textValue, this.textValue, this.textValue, this.textValue)
    //   .then(loginAccount => {
    //     if (ValidateHelper.IsNotNullOrUndefined(loginAccount)) {
    //       this.accountInfoDTO = loginAccount;
    //       const cacheItem = new CacheItem(this.value, loginAccount, 600);
    //       this.$store.dispatch('ObjectCache/addItemAction', cacheItem);
    //       this.$emit('valueChanged', this.accountInfoDTO.iD);
    //     }
    //   });
  }

  @Watch('value')
  refresh() {
    this.setTextValue();
  }
}
